import './index.module.css';
import 'react-toastify/dist/ReactToastify.css';

import * as React from 'react';
import * as ReactDOM from 'react-dom/client';

import { initializeEnvironment } from './environment/environment';
import { initWebEnv } from './store/utils/env/env.manager';

import { LocalStorage } from './utils/storage/storage';
import { WebI18n } from './utils/i18n/i18n';
import { initWebI18n, initWebI18nReport } from './store/utils/i18n/strings.manager';
import { initWebStorage } from './store/utils/storage/storage.manager';
import { register as registerServiceWorker, unregister as unregisterServiceWorker } from './registerServiceWorker';

initWebEnv(initializeEnvironment(process.env));

initWebStorage(new LocalStorage());
initWebI18n(new WebI18n());
initWebI18nReport(new WebI18n());

const App = require('./App').default;

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <App />
);

// if online AND/OR check version number!?
if (window.navigator.onLine) {
  // check version number from env?
  unregisterServiceWorker();
}

registerServiceWorker();
